export default __webpack_public_path__ + "static/media/86.07be05e5.png";